var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "createAlertModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.create_alert"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createAlert()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-1",
            label: this.$t("message.name"),
            "label-for": "input-1",
            "label-class": "required",
          },
        },
        [
          _c("b-form-input", {
            staticClass: "required",
            attrs: { id: "input-1", required: "", trim: "" },
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-2",
            label: this.$t("admin.scope"),
            "label-for": "input-2",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-2",
              options: _vm.availableScopes,
              required: "",
            },
            model: {
              value: _vm.scope,
              callback: function ($$v) {
                _vm.scope = $$v
              },
              expression: "scope",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-3",
            label: this.$t("admin.notification_level"),
            "label-for": "input-3",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-3",
              options: _vm.availableLevels,
              required: "",
            },
            model: {
              value: _vm.notificationLevel,
              callback: function ($$v) {
                _vm.notificationLevel = $$v
              },
              expression: "notificationLevel",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-4",
            label: this.$t("admin.publisher"),
            "label-for": "input-4",
            "label-class": "required",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-4",
              options: _vm.availablePublishers,
              required: "",
            },
            model: {
              value: _vm.publisher,
              callback: function ($$v) {
                _vm.publisher = $$v
              },
              expression: "publisher",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("admin.alert_trigger_type") } },
        [
          _c("b-form-radio-group", {
            attrs: {
              options: [
                {
                  text: _vm.$t("admin.alert_trigger_type_event"),
                  value: "EVENT",
                },
                {
                  text: _vm.$t("admin.alert_trigger_type_schedule"),
                  value: "SCHEDULE",
                },
              ],
              name: "radios-btn-default",
              "button-variant": "outline-primary",
              buttons: "",
            },
            model: {
              value: _vm.triggerType,
              callback: function ($$v) {
                _vm.triggerType = $$v
              },
              expression: "triggerType",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }